// client/src/components/Layout.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePendingBadge } from '../context/PendingBadgeContext';
import { AIMATCH_TAB_ACTIVATE } from '../utils/tabActivate';
import './Layout.css';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { pendingCount } = usePendingBadge();

  const onNavClick = (path) => {
    navigate(path);
    window.dispatchEvent(new CustomEvent(AIMATCH_TAB_ACTIVATE, { detail: { path } }));
  };

  const menuItems = [
    { path: '/discover', icon: '🔍', activeIcon: '🔍', label: '发现' },
    { path: '/messages', icon: '💬', activeIcon: '💬', label: '消息', badge: pendingCount },
    { path: '/activities', icon: '🎉', activeIcon: '🎉', label: '活动' },
    { path: '/profile', icon: '👤', activeIcon: '👤', label: '我的' }
  ];

  return (
    <div className="layout">
      <div className="content">
        {children}
      </div>

      <div className="bottom-nav">
        {menuItems.map(item => {
          const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
          return (
            <div
              key={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
              onClick={() => onNavClick(item.path)}
            >
              <div className="nav-icon">
                {isActive ? item.activeIcon : item.icon}
                {item.badge > 0 && (
                  <span className="badge">{item.badge}</span>
                )}
              </div>
              <div className="nav-label">{item.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Layout;
